export function CarriSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/carri.svg'"></ng-include>`
    }
}